// extracted by mini-css-extract-plugin
export default {"chart":"ContractType_chart__W2+rW","legend":"ContractType_legend__qKy3d","indicator":"ContractType_indicator__hsX93","color":"ContractType_color__I+yf-"};